import MedicalProvider from './MedicalProvider';
import useMedicalProviderList from '../../hooks/useMedicalProviderList';
import { reportSectionClasses } from '../common/formClasses';
import { buildProviderKey } from '../../utils/medicalProviderHelpers';

const MedicalProviderList = ({ providerType }) => {
    const { providers, isLocked } = useMedicalProviderList({ providerType });

    return (
        <>
            {providers.map(({ provider, providerIndex }) => (
                <div key={buildProviderKey({ provider })} className={`${reportSectionClasses} p-6 relative mb-6`}>
                    <MedicalProvider providerIndex={providerIndex} providerType={providerType} isLocked={isLocked} />
                </div>
            ))}
        </>
    );
};

export default MedicalProviderList;
